import { GitRepository } from "TFS/VersionControl/Contracts";
import { WikiPage } from "TFS/Wiki/Contracts";

/**
 * Contract to bind page content and page content version
 */
export interface VersionedPage {
    version: string;
    page: WikiPage;
}

export interface GitRepositoryData {
    cloneUrl: string;
    repository: GitRepository;
    sshEnabled: boolean;
    sshUrl: string;
}
